module.exports = __webpack_public_path__ + "assets/img/learning1.f6642b4f.png";